








































































import { Partner } from '@/modules/kartoteka/partner';

import Base from './Base.vue';
import { RozsahDate } from '../constants';
import { editMutations } from '../store/types';

export default Base.extend({
	name: 'ZakazkaND',
	components: {
		BaseFilterSestav: Base,
		PartnerSelect: Partner.components.Select,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				zakaznik: `${this.storeUri}/${editMutations.ZAKAZNIK_SELECT_MAPPER}`,
				pojistovna: `${this.storeUri}/${editMutations.POJISTOVNA_SELECT_MAPPER}`,
				leasZakaznik: `${this.storeUri}/${editMutations.LEASING_SELECT_MAPPER}`,
			};
		},
	},
	created() {
		this.RozsahDate = RozsahDate.casMinulyMesic;
	},
});
